import { cms } from './config';

const NEWS_PER_PAGE = 3;

async function getNews(params) {
  const { data } = await cms.get('', {
    params: { contentType: 'news', ...params },
  });
  return data;
}

export async function getList(page = 1) {
  const skip = page > 1 ? (Number(page) - 1) * NEWS_PER_PAGE : undefined;
  return getNews({
    limit: NEWS_PER_PAGE,
    skip,
    withLinks: true,
  });
}

export async function getNewsPage({ slug }) {
  return getNews({ slug });
}

export async function getLatest() {
  return getNews({ limit: 4 });
}
